<template>
    <defaultSec title="工单工作流角色配置">
        <el-alert
            class="config-alert"
            title="流程角色修改后只影响后续新建节点；物理删除权限保存后立即生效。物理删除不可恢复，请仅配置必要人员。"
            type="warning"
            :closable="false"
            show-icon>
        </el-alert>

        <el-row v-loading="loading" :gutter="16">
            <el-col v-for="role in roles" :key="role.roleCode" :xs="24" :sm="12" :lg="8">
                <el-card class="role-card" shadow="never">
                    <div slot="header" class="card-header">
                        <span>{{ role.roleName }}</span>
                        <el-tag size="mini" :type="role.multiple ? 'success' : 'info'">
                            {{ role.multiple ? '可配置多人' : '仅限一人' }}
                        </el-tag>
                    </div>

                    <div class="role-description">{{ roleDescription(role.roleCode) }}</div>
                    <el-select
                        v-model="formValues[role.roleCode]"
                        :multiple="role.multiple"
                        filterable
                        clearable
                        collapse-tags
                        placeholder="请选择人员"
                        class="role-select">
                        <el-option
                            v-for="user in userList"
                            :key="user.USER_ID"
                            :label="userDisplayName(user)"
                            :value="user.USER_ID">
                        </el-option>
                    </el-select>

                    <div class="current-members">
                        当前配置：{{ currentMemberNames(role) }}
                    </div>
                    <el-button
                        type="primary"
                        size="small"
                        :loading="savingRoleCode === role.roleCode"
                        @click="saveRole(role)">
                        保存{{ role.roleName }}
                    </el-button>
                </el-card>
            </el-col>
        </el-row>
    </defaultSec>
</template>

<script>
export default {
    name: 'workOrderWorkflowRoleConfig',
    data(){
        return {
            loading:false,
            savingRoleCode:'',
            roles:[],
            userList:[],
            formValues:{
                COMPLAINT_SPECIALIST:[],
                PAYMENT_SPECIALIST:'',
                RESPONSIBILITY_CONFIRMER:'',
                PHYSICAL_DELETE_OPERATOR:[],
            },
            componentDestroyed:false,
        }
    },
    created(){
        this.loadPage()
    },
    beforeDestroy(){
        this.componentDestroyed = true
    },
    methods:{
        loadPage(){
            this.loading = true
            Promise.all([
                this.$apiGet('lechun-csms/workOrder/workflow/config/roles',{}),
                this.$apiGet('lechun-baseservice/user/getUserListForDorpbox',{}),
            ]).then(([roles, users]) => {
                if(this.componentDestroyed) return
                this.roles = roles || []
                this.userList = users || []
                this.syncFormValues()
            }).finally(() => {
                if(this.componentDestroyed) return
                this.loading = false
            })
        },
        syncFormValues(){
            const next = {
                COMPLAINT_SPECIALIST:[],
                PAYMENT_SPECIALIST:'',
                RESPONSIBILITY_CONFIRMER:'',
                PHYSICAL_DELETE_OPERATOR:[],
            }
            this.roles.forEach(role => {
                const ids = (role.members || []).map(member => member.userId)
                next[role.roleCode] = role.multiple ? ids : (ids[0] || '')
            })
            this.formValues = next
        },
        saveRole(role){
            const value = this.formValues[role.roleCode]
            const userIds = role.multiple ? (value || []) : (value ? [value] : [])
            if(!userIds.length){
                this.$message.warning(`${role.roleName}不能为空`)
                return
            }
            this.savingRoleCode = role.roleCode
            this.$apiPost('lechun-csms/workOrder/workflow/config/role/save',{
                roleCode:role.roleCode,
                userIds,
            }).then(() => {
                this.$message.success(`${role.roleName}配置已保存`)
                return this.reloadRoles()
            }).finally(() => {
                if(this.componentDestroyed) return
                this.savingRoleCode = ''
            })
        },
        reloadRoles(){
            return this.$apiGet('lechun-csms/workOrder/workflow/config/roles',{}).then(roles => {
                if(this.componentDestroyed) return
                this.roles = roles || []
                this.syncFormValues()
            })
        },
        userDisplayName(user){
            return user ? (user.USER_NAME || user.USER_NICK || user.USER_ID) : '-'
        },
        currentMemberNames(role){
            const names = (role.members || []).map(member => member.userName).filter(Boolean)
            return names.length ? names.join('、') : '未配置'
        },
        roleDescription(roleCode){
            const descriptions = {
                COMPLAINT_SPECIALIST:'处理升级工单，可关闭工单或继续流转到赔付。',
                PAYMENT_SPECIALIST:'处理赔付工单，回填打款凭证并完成初步责任划分。',
                RESPONSIBILITY_CONFIRMER:'确认或修改赔付责任划分，通过后关闭工单。',
                PHYSICAL_DELETE_OPERATOR:'可在工单详情执行不可恢复的物理删除，操作时必须再次输入完整工单号确认。',
            }
            return descriptions[roleCode] || ''
        },
    },
}
</script>

<style scoped>
.config-alert { margin-bottom: 16px; }
.role-card { min-height: 260px; }
.card-header { display: flex; align-items: center; justify-content: space-between; }
.role-description { min-height: 42px; margin-bottom: 16px; color: #606266; line-height: 21px; }
.role-select { width: 100%; margin-bottom: 14px; }
.current-members { min-height: 40px; margin-bottom: 14px; color: #909399; line-height: 20px; }
</style>
